import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_wifi",
  "use": "svg_wifi-usage",
  "viewBox": "0 0 21 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 16\" id=\"svg_wifi\"><path d=\"M9.967 9.2a5.889 5.889 0 0 1 4.166 1.722l-.9.9a4.733 4.733 0 0 0-6.533 0l-.922-.9A5.843 5.843 0 0 1 9.967 9.2ZM2.833 7.956l.9.9a8.822 8.822 0 0 1 12.467 0l.9-.9a10.089 10.089 0 0 0-14.267 0ZM10 .9A14.067 14.067 0 0 0 0 5.044L.9 6a12.878 12.878 0 0 1 18.211 0l.9-.9A14.067 14.067 0 0 0 10 .9ZM8.444 13.611l1.49 1.49 1.488-1.49a2.11 2.11 0 0 0-2.978 0Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol